'use client';

import { GlucoseResponse } from 'components/glucose-db/GlucoseResponse';
import { HeroSection_GlucoseDb } from 'components/glucose-db/HeroSection';
import { CustomImage as Image } from 'components/shared';
import CustomLink from 'components/shared/CustomLink';
import type { FoodSummary } from 'lib/ogdb/types';
import styles from './ogdb-client.module.css';

export default function GlucoseResponseDB({
  topFoods,
  bottomFoods,
}: {
  topFoods: FoodSummary[];
  bottomFoods: FoodSummary[];
}) {
  return (
    <main style={{ backgroundColor: '#000000', position: 'relative' }}>
      <div className={styles.bgImageContainer}>
        <Image
          src={`web_v2/backgrounds/glucose_bg.png`}
          alt="Glucose Response"
          fill
        />
      </div>
      <HeroSection_GlucoseDb />
      <GlucoseResponse topFoods={topFoods} bottomFoods={bottomFoods} />
      <div
        style={{
          color: '#ffffff',
          textAlign: 'center',
          paddingBottom: '5rem',
          fontSize: '1.3rem',
        }}
      >
        <CustomLink
          style={{
            color: '#ffffff',
            fontWeight: 500,
            textDecoration: 'underline',
          }}
          href="https://ultrahumanapp.notion.site/Disclaimers-for-Ultrahuman-M1-Food-Items-Database-f21d014ad4ca4f538064c5aa21f93157?pvs=4"
          target="_blank"
        >
          Disclaimer
        </CustomLink>
      </div>
    </main>
  );
}
